import './tableComponent.css';
import './tableComponent.html.twig';

export default function() {
  const tables = document.querySelectorAll('.table-component');

  if (!tables) {
    return;
  }

  tables.forEach(element => {
    const input = element.querySelector('.table-component__control');
    const label = element.querySelector('.table-component__label');
    if (input && label) {
      if (!label.getAttribute('for')) {
        label.addEventListener('click', () => {
          input.click();
        });
      }
    }

    const richTexts = element.querySelectorAll('.rich-text');

    richTexts.forEach(el => {
      const table = el.querySelector('table');
      const tr = table.querySelectorAll('tbody tr');
      const th = table.querySelectorAll('th');
      const thArray = Array.from(th);

      for (let i = 0; i < tr.length; i++) {
        const td = tr[i].querySelectorAll('td');
        const tdArray = Array.from(td);
        for (let j = 0; j < tdArray.length; j++) {
          if (j === thArray.length) {
            continue;
          }
          const headerLabel = thArray[j].innerHTML;
          tdArray[j].setAttribute('data-th', headerLabel);
        }
      }
    });
  });
}
